import "./style.css";
import videoSrcHq from "./public/yichi_hq.webm";
import videoSrcHqMp4 from "./public/yichi_hq_2.mp4";
import {
  useEffect,
  useRef,
  useState,
  type Dispatch,
  type RefObject,
  type SetStateAction,
} from "react";

const toggleVid = (
  showVid: boolean,
  setShowVid: Dispatch<SetStateAction<boolean>>,
  videoRef: RefObject<HTMLVideoElement | null>,
  videoRefHq: RefObject<HTMLVideoElement | null>,
) => {
  setShowVid(!showVid);
  if (!showVid) {
    videoRef.current?.pause();
    videoRefHq.current?.play();
  } else {
    videoRef.current?.play();
    videoRefHq.current?.pause();
  }
};

export function App() {
  const videoRef = useRef<HTMLVideoElement>(null);
  const videoRefHq = useRef<HTMLVideoElement>(null);
  const [showVid, setShowVid] = useState(false);

  return (
    <div>
      <video
        ref={videoRef}
        onLoadedMetadata={() => {
          if (videoRef.current) {
            videoRef.current.currentTime = 10;
          }
        }}
        preload="none"
        autoPlay
        playsInline
        loop
        muted
        style={{
          position: "absolute",
          width: "100%",
          height: "100%",
          objectFit: "cover",
          zIndex: -1,
        }}
      >
        <source src={videoSrcHq} type="video/webm" />
      </video>

      <div
        style={{
          display: "flex",
          justifyContent: "space-around",
          alignItems: "center",
          color: "hotpink",
          fontSize: "24px",
          padding: "20px",
        }}
      >
        <div style={{ fontFamily: "Rubik Glitch" }}>Music</div>

        <div style={{ fontFamily: "Rubik Glitch" }}></div>

        <div style={{ fontFamily: "Rubik Glitch" }}>About</div>
      </div>

      <div
        style={{
          position: "absolute",
          top: "10%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          display: "flex",
          fontSize: "52px",
          fontFamily: "Rubik Glitch",
          zIndex: 99,
          color: "hotpink",
        }}
      >
        Yichi
      </div>

      <div
        style={{
          position: "absolute",
          top: "70%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          display: "flex",
          color: "white",
          borderRadius: "8px",
          padding: "12px 24px",
          border: "2px solid white",
          borderColor: "hotpink",
          cursor: "pointer",
          backgroundColor: "hotpink",
          fontSize: "20px",
          fontFamily: "Rubik Glitch",
        }}
        onClick={() => {
          toggleVid(showVid, setShowVid, videoRef, videoRefHq);
        }}
      >
        Play Video
      </div>

      <div>
        <video
          ref={videoRefHq}
          controls
          style={{
            display: showVid ? "block" : "none",
            position: "absolute",
            left: "50%",
            top: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: 999,
            borderRadius: 20,
            borderWidth: 3,
            borderStyle: "solid",
            borderColor: "hotpink",
            width: "80%",
            height: "80%",
            objectFit: "cover",
          }}
        >
          <source src={videoSrcHqMp4} type="video/mp4" />
        </video>

        <div
          style={{
            cursor: "pointer",
            display: showVid ? "block" : "none",
            position: "absolute",
            left: "89%",
            top: "9%",
            width: 32,
            height: 32,
            borderRadius: 16,
            color: "gray",
            backgroundColor: "hotpink",
            zIndex: 1000,
            textAlign: "center",
            justifyContent: "center",
            alignContent: "center",
          }}
          onClick={() => {
            toggleVid(showVid, setShowVid, videoRef, videoRefHq);
          }}
        >
          X
        </div>
      </div>

      <footer>
        <div
          style={{
            position: "absolute",
            bottom: "10px",
            width: "100%",
            textAlign: "center",
            color: "#ffffff",
            fontFamily: "Rubik Storm",
          }}
        >
          {`© ${new Date().getFullYear()} Yichi Dang. All rights reserved.`}
        </div>
      </footer>
    </div>
  );
}

export default App;
